import { Component, Input } from '@angular/core';

@Component({
    selector: 'partner-provide-access',
    templateUrl: './partner-provide-access.component.html',
    styleUrls: ['./partner-provide-access.component.scss']
})
export class PartnerProvideAccessComponent {
    @Input()
    public onHide: () => void = () => { };

    public visible: boolean = true;

    public onDialogHide(): void {
        this.onHide();
    }

    public onCancelClick(): void {
        this.visible = false;
    }
}
